<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title"> Báo cáo</div>
      </div>
      <div class="card card-w-title" v-if="$myConstants.checkRoleGroup('report_service_supplies', 'list')">
        <div class="p-grid box-row-data">
          <div class="p-col-6" style="padding-left: 0px;" ><span style="font-weight: 700; font-style: normal; font-size: 20px;">Vật tư - dịch vụ đã sử dụng</span></div>
          <div class="p-col-6 text-right"><Button class="p-button-warning" :label="'Quay lại'" @click="backList" /></div>
        </div>
        <div class="p-grid box-row-data">
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <label>Ngày cập nhật <span class="error">*</span></label>
            <div class="box">
              <Calendar dateFormat="dd/mm/yy" v-model="list_filter_data['start_date_filter']" style="width: calc(50% - 10px);" placeholder="Từ ngày"  @date-select="onFilter($event,'date_from_to','start_date_filter')" />
              -
              <Calendar dateFormat="dd/mm/yy" v-model="list_filter_data['end_date_filter']" style="width: calc(50% - 10px);" placeholder="Đến ngày" @date-select="onFilter($event,'date_from_to','end_date_filter')" />
            </div>
            <small v-if="validationErrors && validationErrors['start_date_filter']" class="p-invalid" >{{validationErrors['start_date_filter']}}</small>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <label>Đơn vị thực hiện</label>
            <div class="box">
              <MultiSelect style="width: 100%;" v-model="list_filter_data['selected_organization_filter']" :filter="true" :options="list_filter_organization" optionLabel="name" optionValue="id" placeholder="Tất cả" @change="onFilter($event,'MultiSelect','selected_organization_filter')" />
              <!--<Dropdown  style="width: 100%;" :filter="true"   placeholder="Chọn đơn vị" inputId="organization_id"  optionLabel="label"  optionValue="value" />-->
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data">
            <label>Vật tư - dịch vụ</label>
            <div class="box">
              <MultiSelect style="width: 100%;" v-model="list_filter_data['selected_service_supplies']" :filter="true" :options="list_service_supplies" optionLabel="lable" optionValue="id" placeholder="Tất cả" @change="onFilter($event,'MultiSelect','selected_service_supplies')"/>
              <!--<Dropdown  style="width: 100%;" :filter="true"   placeholder="Chọn đơn vị" inputId="organization_id"  optionLabel="label"  optionValue="value" />-->
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 box-item-data box-button-filter">
            <div class="box box-item-button-filter">
              <Button
                  style="width: 96px"
                  class="p-button-info btn-custom"
                  :label="'Áp dụng'"
                  type="button"
                  @click="process_filter"
              > </Button>
              <Button
                  style="margin-left: 16px;width: 96px"
                  class="p-button-danger btn-custom"
                  :label="'Hủy'"
                  @click="cancel_filter"
              />

            </div>
          </div>
        </div>
        <div class="p-grid box-row-data">
          <div class="p-col-12 p-md-6 p-lg-8 box-item-data">
            <div class="box">
              <div class="import-data download-data" ><!--v-if="$myConstants.checkRoleGroup('maintenance', 'download')"-->
                <button :disabled="DisableExport == true" class="download-file" @click="exportDataExcel" >
                  <i class="pi pi-download"></i>Xuất dữ liệu
                </button>
                <span >(Dữ liệu được xuất theo thông tin hiển thị ở bảng bên dưới)</span>
              </div>
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-4 box-item-data" style="text-align: right">
            <div class="box">
              <span >Hiển thị <b>{{ list_colunm_display.length }}</b>/<b>{{ list_column_select.length }}</b> cột</span>
              <MultiSelect style="margin-left: 8px;max-width: 120px" v-model="list_colunm_display" :filter="true" :options="list_column_select" optionLabel="name" optionValue="key" placeholder="Chọn cột" @before-hide="process_load_data" /><!--@change="process_load_data"-->
            </div>
          </div>
        </div>
        <div class="list-data" ><!--v-if="$myConstants.checkRoleGroup('maintenance', 'list')"-->
          <!--<div class="list-title">
            <span class="p-m-0">Danh sách kế hoạch bảo trì định kỳ</span>
            <span class="p-input-icon-left" v-if="$myConstants.checkRoleGroup('maintenance', 'update_status')">
              <Button
              :style="(disable_update) ? 'background-color: rgba(153, 153, 153, 1);border: 1px solid #c8c9c9;':''"
              :disabled="disable_update"
              :label="'Cập nhật'"
              type="button"
              v-on:click="update_assignment()"
              > </Button>
            </span>
          </div>-->
          <BaseCommon v-if="dataModel"

            :classDatatable="'list_warranty_activation'"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            :dateTypeDateFilterDefault="dateTypeDateFilterDefault"
            :map_custom_filter="map_custom_filter"
            @filter="filterData"
            @callback="callbackListData"
            @info_overview="info_overview"
            :columnsDisplays="columnsDisplays"
            @filterExport="whereExport"
          ></BaseCommon><!--
           :labelHeaderAction="'Chi tiết'"
            v-on:action-click="onActionClicked"
            :actions="getRowActions()"
          -->
        </div>
      </div>
    </div>
    <Dialog
        class="dialog-comfirm-common"
        :visible.sync="showConfirmDialog"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :closable="true"
    >
      <div class="box_body_popup" >
        <div v-if="creenConfirmDialog == 'export_success'">
          <div class="box_title_suceess"><img class="img_noti" :src="check_success_img" /><span class="title_noti" style="">Thành công</span></div>
          <p class="p_title_1" style="text-align: left">Báo cáo <span style="font-weight: 700">Vật tư - dịch vụ đã sử dụng</span> đã xuất dữ liệu thành công. Vui lòng thực hiện tải về tại module Lịch sử xuất dữ liệu.</p>
          <div class="box_btn">
            <Button
                icon="pi pi-chevron-circle-right"
                iconPos="right"
                class="btn-custom"
                :label="'Lịch sử xuất dữ liệu'"
                type="button"
                @click="redirect_ToHistory"
            > </Button>
          </div>
        </div>
        <div v-if="creenConfirmDialog == 'export_err'">
          <div class="box_title_err"><img class="img_noti" :src="err_massage_img" /><span class="title_noti" style="">Thất bại</span></div>
          <p class="p_title_1" style="text-align: left">Quá trình xuất dữ liệu báo cáo <span style="font-weight: 700;">Vật tư - dịch vụ đã sử dụng</span> đã xảy ra vấn đề. Bạn vui lòng thực hiện lại thao tác xuất dữ liệu.</p>
        </div>
      </div>
      <template #header>
        <div>
          <span class="title-confirm" >Thông báo</span>
          <!--<span class="description-confirm">asdasdas</span>-->
        </div>
      </template>
    </Dialog>
    <!--<OverlayPanel ref="op" :dismissable="false" style="width: 335px;">
      <Listbox  v-model="selectedCountries" :options="countries" :multiple="true" :filter="true" optionLabel="name" listStyle="max-height:250px" style="width:100%">
        <template #option="slotProps">
          <div class="country-item">
           &lt;!&ndash; <img src="../../assets/images/flag_placeholder.png" :class="'flag flag-' + slotProps.option.code.toLowerCase()" />&ndash;&gt;
            <div>{{slotProps.option.name}}</div>
          </div>
        </template>
      </Listbox>
    </OverlayPanel>-->
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseCommon from './core_list';
import moment from "moment";
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0,
      disable_update:true,
      listDataExport:[],
      showConfirmDialog:false,
      creenConfirmDialog:'export_success',
      check_success_img: window.origin + '/assets/images/check_success.png',
      err_massage_img: window.origin + '/assets/images/err_massage.png',
      dateTypeDateFilterDefault:null,
      start_date_filter:null,
      end_date_filter:null,
      selected_organization_filter:null,
      list_filter_organization:[],
      selected_category_filter:null,
      list_filter_category:[],
      selected_province_filter:null,
      list_filter_province:[],
      selected_product_filter:null,
      list_filter_product:[],
      list_service_supplies:[],
      selected_warranty_status_filter:null,
      list_type_service_filter :[ { value: 0, label: 'Đổi sản phẩm'},{ value: 1, label: 'Trả sản phẩm'}],
      list_current_status:[{ value: 6, label: 'Chờ gửi yêu cầu'},{ value: 0, label: 'Đang yêu cầu'}, { value: 1, label: 'Chờ thẩm định'}, { value: 2, label: 'Hủy yêu cầu'}, { value: 3, label: 'Tự động duyệt'}, { value: 4, label: 'Không duyệt'}, { value: 5, label: 'Đã duyệt'}],
      list_filter_warranty_status:[{ value: 0, label: 'Chưa kích hoạt', style: 'color: #FF6600; font-weight: 500;'}, { value: 2, label: 'Chờ kích hoạt', style: 'color: #990099; font-weight: 500;'}, { value: 3, label: 'Đã kích hoạt', style: 'color: #00CC00; font-weight: 500;'}, { value: 4, label: 'Hết bảo hành', style: 'color: #0000CC;font-weight: 500;'}, { value: 6, label: 'Sản phẩm huỷ', style: 'color: #000;font-weight: 500;'}],
      list_filter_data: {},
      map_custom_filter:[],
      validationErrors: {},
      totalChange:0,
      totalReturn:0,
      totalChangeWaitRequest:0,
      totalChangeWaitingAppraisal:0,
      totalChangeAreAsking:0,
      totalChangeApproved:0,
      totalChangeCancelRequest:0,
      totalChangeDisagree:0,
      totalReturnWaitingAppraisal:0,
      totalReturnAreAsking:0,
      totalReturnApproved:0,
      totalReturnCancelRequest:0,
      totalReturnDisagree:0,
      totalReturnAutoApproved:0,
      columnsDisplays:[],
      list_colunm_display:[
          "modified_date_text","code_text","name_text","unit_service_text","number_text","organization_text"
      ],//Số cột hiển thị
      list_column_select:[
        {key:'modified_date_text',name:'Ngày cập nhật'},
        {key:'code_text',name:'Mã vật tư - dịch vụ'},
        {key:'name_text',name:'Tên vật tư - dịch vụ'},
        {key:'unit_service_text',name:'Đơn vị tính'},
        {key:'number_text',name:'Số lượng'},
        {key:'organization_text',name:'Đơn vị thực hiện'}
      ],//tổng số cột
      columnShowShowExport : [],
      userID : null,
      filter_export : {},
      DisableExport : true
    }
  },
  mounted () {
    this.initData();
    if(this.$store.getters.fullname !== undefined && this.$store.getters.fullname !== null){
      if(this.$store.getters.fullname.id !== undefined && this.$store.getters.fullname.id !== null && this.$store.getters.fullname.id !== ''){
        this.userID = this.$store.getters.fullname.id
      }
    }
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    backList() {
      this.$router.push({path: '/admin/report'});
    },
    info_overview(total_overview){
      if (total_overview);
      /*this.totalChangeWaitRequest = (!this.$myConstants.isEmpty(total_overview["totalChangeWaitRequest"])) ? total_overview["totalChangeWaitRequest"]:0;
      this.totalChangeWaitingAppraisal = (!this.$myConstants.isEmpty(total_overview["totalChangeWaitingAppraisal"])) ? total_overview["totalChangeWaitingAppraisal"]:0;
      this.totalChangeAreAsking = (!this.$myConstants.isEmpty(total_overview["totalChangeAreAsking"])) ? total_overview["totalChangeAreAsking"]:0;
      this.totalChangeApproved = (!this.$myConstants.isEmpty(total_overview["totalChangeApproved"])) ? total_overview["totalChangeApproved"]:0;
      this.totalChangeCancelRequest = (!this.$myConstants.isEmpty(total_overview["totalChangeCancelRequest"])) ? total_overview["totalChangeCancelRequest"]:0;
      this.totalChangeDisagree = (!this.$myConstants.isEmpty(total_overview["totalChangeDisagree"])) ? total_overview["totalChangeDisagree"]:0;

      this.totalReturnWaitingAppraisal = (!this.$myConstants.isEmpty(total_overview["totalReturnWaitingAppraisal"])) ? total_overview["totalReturnWaitingAppraisal"]:0;
      this.totalReturnAreAsking = (!this.$myConstants.isEmpty(total_overview["totalReturnAreAsking"])) ? total_overview["totalReturnAreAsking"]:0;
      this.totalReturnApproved = (!this.$myConstants.isEmpty(total_overview["totalReturnApproved"])) ? total_overview["totalReturnApproved"]:0;
      this.totalReturnCancelRequest = (!this.$myConstants.isEmpty(total_overview["totalReturnCancelRequest"])) ? total_overview["totalReturnCancelRequest"]:0;
      this.totalReturnDisagree = (!this.$myConstants.isEmpty(total_overview["totalReturnDisagree"])) ? total_overview["totalReturnDisagree"]:0;
      this.totalReturnAutoApproved = (!this.$myConstants.isEmpty(total_overview["totalReturnAutoApproved"])) ? total_overview["totalReturnAutoApproved"]:0;

      this.totalChange = (this.totalChangeWaitRequest+this.totalChangeWaitingAppraisal+this.totalChangeAreAsking+this.totalChangeApproved+this.totalChangeCancelRequest+this.totalChangeDisagree);
      this.totalReturn = (this.totalReturnWaitingAppraisal+this.totalReturnAreAsking+this.totalReturnApproved+this.totalReturnCancelRequest+this.totalReturnDisagree+this.totalReturnAutoApproved);
*/
    },
    async validationFilterData() {
      //var vm =this;
      this.validationErrors = {};
      if (this.$myConstants.isEmpty(this.list_filter_data["start_date_filter"]) || this.$myConstants.isEmpty(this.list_filter_data["end_date_filter"])){
        this.validationErrors['start_date_filter'] = 'Nhập thời gian cập nhật ';
      }else {
        var check_start_date = moment(this.list_filter_data["start_date_filter"]).tz(this.$myConstants.timeZone()).format('YYYYMMDD');
        var check_end_date = moment(this.list_filter_data["end_date_filter"]).tz(this.$myConstants.timeZone()).format('YYYYMMDD');
        if (check_end_date < check_start_date){
          this.validationErrors['start_date_filter'] = 'Nhập ngày bắt đầu không được lớn hơn ngày kết thúc ';
        }
      }
      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    cancel_filter(){
      this.DisableExport = true
      this.list_filter_data = {};
      this.map_custom_filter = [];
      this.process_load_data();
    },
    async process_filter() {
      //var vm = this;
      await this.validationFilterData();
      if (Object.entries(this.validationErrors).length === 0) {
        /*this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);*/
        //this.map_custom_filter
        this.DisableExport = false;
        this.process_load_data();
      }
    },
    async process_load_data() {
      console.log("555555");
      this.processColunmDisplays();
      this.dataModel = DataServices.getModel('report_service_supplies');
      this.dataModel.processData([]);
      this.listDataExport = [];
      this.listData = [];
      this.componentKey++;
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    initData() {
      setTimeout(async () => {
        //if (this.$myConstants.checkRoleGroup('maintenance', 'list')) {
          await this.initParams();
        //}
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async initParams() {

      /*this.filters = {
        date_maintenance: {
          from:  new Date(moment().startOf('month').format('YYYY-MM-DD')),
          to: new Date(moment().endOf('month').format('YYYY-MM-DD'))
        },
        type_maintenance:0,
        is_assignment:false
      };*/

      var vm = this;
      this.dateTypeDateFilterDefault = 2;
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      //this.filters.address_info = "aa";
      this.modelName = 'report_service_supplies';

      //load filter đơn vị
      this.$coreService.list_all_organization().then(async (dataOr) => {
        vm.list_filter_organization = dataOr;
      }).catch(async () => {
        vm.list_filter_organization = [];
      });
      this.$coreService.list_all_service_supplies().then(async (data) => {
        vm.list_service_supplies = data;
      }).catch(async () => {
        vm.list_service_supplies = [];
      });

      this.processColunmDisplays();
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData([]);
      this.listDataExport = [];
      this.listData = [];
      this.componentKey++;
      this.$store.commit('setLoading', false);
    },
    processColunmDisplays(){
      var colunmHide = [];
      var columnShow = []
      for (var i=0;i<this.list_column_select.length;i++){
        var key = this.list_column_select[i].key;
        if (this.list_colunm_display.indexOf(key) == -1){
          colunmHide.push(key);
        }else{
          columnShow.push(key);
        }
      }
      this.columnsDisplays = colunmHide;
      this.columnShowExport = columnShow;
    },
    dang_phat_trien(){
      alert('Đang phát triển');
    },
    redirect_ToHistory(){
      this.$router.push({path: '/admin/history-export'});
    },
    async  filterData(payload){
      console.log("assssssssss:",this.filters)
      this.listDataExport = payload.filteredValue;
    },
    async exportDataExcel(){
    var columnExport = this.columnShowExport;
    if (columnExport.length < 1){
      this.$toast.add({
        severity: 'error',
        summary: 'Thông báo',
        detail: 'Không tồn tại cột dữ liệu xuất',
        life: 3000
      });
      return false;
    }
    this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
    this.$store.commit('setLoading', true);
      try {
        var start_date_filter = moment(this.list_filter_data["start_date_filter"]).format('DDMMYY');
        var end_date_filter = moment(this.list_filter_data["end_date_filter"]).format('DDMMYY');
        //console.log(start_date_filter)
        //console.log(end_date_filter)
        var dataResponse = await this.$coreService.callApiPost('/export_excel/report_service_supplies',{column_export:columnExport,user_id : this.userID,filter_export : this.filter_export},{})
        var key_s3 = dataResponse.data.data.key_s3;
        var dataResponseDownload = await this.$coreService.callApiDownloadPost('/export_excel/read_file_export',{key_s3:key_s3},{})
        var url = URL.createObjectURL(new Blob([dataResponseDownload.data], {
          type: 'application/vnd.ms-excel'
        }))
        const link = document.createElement('a')
        link.href = url;
        var file_excel = 'BC_VatTuDichVu_'+moment().tz("Asia/Bangkok").format('DDMMYYYY')+'_'+moment().tz("Asia/Bangkok").format('HHmmss')+'_'+start_date_filter+'-'+end_date_filter+'.xlsx';
        link.setAttribute('download', file_excel)
        document.body.appendChild(link)
        link.click()
        this.showConfirmDialog = true;
        this.creenConfirmDialog = 'export_success';

    } catch (err) {
        console.log("err:",err);
        this.showConfirmDialog = true;
        this.creenConfirmDialog = 'export_err';
      }
      this.$store.commit('setLoading', false);
    },
    callbackListData(col, payload) {
      //var vm = this;
      //console.log("5555555555");
      if (col.name == 'is_assignment') {
        this.disable_update = false;
        if (payload);
      }
    },
   async update_assignment(){
      if (this.disable_update == false){
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var list_id_update_false = [];
        var list_id_update_true = [];
        for (var i=0;i<this.listData.length;i++){
          if (this.listData[i].type_maintenance == 0){
            if (this.listData[i].is_assignment == true){
              list_id_update_true.push(this.listData[i].id);
            }else {
              list_id_update_false.push(this.listData[i].id);
            }
          }
        }
        var count_done = 0;
        var whereInfoTrue = { id: {_in: list_id_update_true} }
        DataServices.updateData('maintenance', {"variables": JSON.stringify({data_update: {is_assignment:  true}, where_key: whereInfoTrue})}).then(async () => {
          count_done++;
          if (count_done == 2){
            this.disable_update = true;
            this.update_assignment_success();
          }
        }).catch(async () => {
          count_done++;
          //báo lỗi 1 lần
          if (count_done == 1){
            this.disable_update = true;
            this.update_assignment_err();
          }
        });

          var whereInfoFalse = { id: {_in: list_id_update_false} }
          DataServices.updateData('maintenance', {"variables": JSON.stringify({data_update: {is_assignment:  false}, where_key: whereInfoFalse})}).then(async () => {
            count_done++;
            if (count_done == 2){
              this.disable_update = true;
              this.update_assignment_success();
            }
          }).catch(async () => {
            count_done++;
            if (count_done == 1){
              this.disable_update = true;
              this.update_assignment_err();
            }
          });
      }
    },
    update_assignment_success(){
      this.$store.commit('setLoading', false);
      this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 });
    },
    update_assignment_err(){
      this.$store.commit('setLoading', false);
      this.$toast.add({
        severity: 'error',
        summary: 'Thông báo',
        detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
        life: 3000
      });
    },
    async onActionClicked(payload) {
      var that = this;
      var action = payload.action
      var data = null
      var appraisal_product_id  = null;
      if (payload.data) {
        data = payload.data
        if (!that.$myConstants.isEmpty(data.data.appraisal_product)){
          if (!that.$myConstants.isEmpty(data.data.appraisal_product.id)){
            appraisal_product_id = data.data.appraisal_product.id;
          }}
      }
      /*console.log("datadata:",data);
      console.log("appraisal_product_id:",appraisal_product_id);*/
      switch (action.name) {
        case 'view':
          if (!that.$myConstants.isEmpty(appraisal_product_id)){
            this.$router.push(action.path + '/' + appraisal_product_id)
          }
          break;
      }
    },
    /*getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
          var process_status = (!that.$myConstants.isEmpty(rowData.process_status)) ? rowData.process_status:null;
          var path = "";
          var modelaction;
          if (that.$myConstants.checkRoleGroup('warranty_repair', 'add')  && (process_status == that.$dataCommon.MAINTENANCE.PROCESS_STATUS.PLAN || process_status == that.$dataCommon.MAINTENANCE.PROCESS_STATUS.MAINTENANCE_NEEDED) ){
            path = "/admin/warranty-repair/function?id_maintenance="+rowData.id;
            buttons.edit = { name: 'add_warranty_repair', text: 'Tiếp nhận', isText: true,  key: 'id', path: path}
            if (that.dataModel.actions) {
               modelaction = that.dataModel.actions(rowData)
              Object.assign(buttons, modelaction);
            }
          }else if (that.$myConstants.checkRoleGroup('warranty_repair', 'view')  && (process_status == that.$dataCommon.MAINTENANCE.PROCESS_STATUS.PROCESSING || process_status == that.$dataCommon.MAINTENANCE.PROCESS_STATUS.FOR_MAINTENANCE) ){
            if (!that.$myConstants.isEmpty(rowData.id_wr_product)){
              var warranty_repair_product_serial_number_id = rowData.id_wr_product;
              path = "/admin/warranty-repair/view-detail/"+warranty_repair_product_serial_number_id;
              buttons.edit = { name: 'view_warranty_repair_product', text: 'Xem', isText: true,  key: 'id', path: path}
              if (that.dataModel.actions) {
                modelaction = that.dataModel.actions(rowData)
                Object.assign(buttons, modelaction);
              }
            }
          }
        return buttons
      }
      return actions
    },*/
    getRowActions() {
      var actions = {}
      var that = this;
      actions.rows = function (rowData) {
        var buttons = {}
        if (rowData.current_status != that.$dataCommon.REQUEST_RETURN.PROCESS_STATUS.WAIT_REQUEST) {
          if (!that.$myConstants.isEmpty(rowData.appraisal_product)){
          if (!that.$myConstants.isEmpty(rowData.appraisal_product.id)){
          buttons.view = {
            name: 'view',
            text: 'Xem',
            isText: true,
            key: 'id',
            path: `/admin/appraisal-product/view-detail`
          }
          if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }
          }
          }
        }
        return buttons
      }
      return actions
    },
    cancelFilter() {
      this.filters = {};
    },
    async onFilter(event,type_input,key) {
      /*console.log(type_input)
      console.log(key)
      console.log("event:",this.list_filter_data)*/
      //this.list_filter_data
      if (type_input == 'date_from_to'){
        if (!this.$myConstants.isEmpty(this.list_filter_data["start_date_filter"]) && !this.$myConstants.isEmpty(this.list_filter_data["end_date_filter"])){
          this.list_filter_data["filter_data_range"] = [this.list_filter_data["start_date_filter"],this.list_filter_data["end_date_filter"]]
        key = 'filter_data_range';
        type_input = 'DateRange';
        }
      }
      this.map_custom_filter[key] = await this.$coreService.convertFilter(type_input,key,this.list_filter_data);
      //console.log("this.map_custom_filter:",this.map_custom_filter)
      //console.log("this.map_custom_filter:",this.map_custom_filter)
      //this.lazyParams.first = 0;
      //this.onLazyEvent()
    },
    async whereExport(e){
      // console.log("EEE",e)
      this.filter_export = e
    }
  }
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
.list_warranty_repair{
  .late_delivery_return_appointment_day{
    color: #CC0000;
  }
}

.import-data .download-file {
  color: #fff;
  border-width: 0px;
  min-width: 165px;
  height: 35px;
  background: #169bd5;
  border: none;
  border-radius: 5px;
  padding: 5px 20px;
}
.download-data{ position: relative; display: flex;
  span{margin-top: 14px; margin-left: 10px;}
}

.dialog-comfirm-common{
  width: 434px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center;
      margin-top: 8px;
    }
    .box_title_suceess{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #009900;margin-left: 8px
      }
    }
    .box_title_err{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #FF0000;margin-left: 8px
      }
    }
  }
}
.box-row-data{
  margin: 0px 0px !important;
  .box-item-data:first-child{
    padding-left: 0px !important;
  }
  .box-item-data:last-child{
    padding-right: 0px !important;
  }
}
.box-button-filter{
  position: relative;
  .box-item-button-filter{
    position: absolute;
    bottom: 16px;
  }
}
.box_overview{
  .box_left_overview{
    border-right: 1px solid #333333;
  }
  .style_title_overview{
    text-align: center;
    margin-bottom: 20px;
    .style_row_overview{
      font-family:'Arial';font-weight:400;
    }
  }
}
</style>
<style>
.p-checkbox .p-hidden-accessible{
  position: unset!important;
}
</style>